module.exports = require("./src/vue-i18n.js");


/*****************
 ** WEBPACK FOOTER
 ** vue-i18n-plugin (bower component)
 ** module id = 3
 ** module chunks = 0
 **/